



























































































import Vue from "vue";
import { callApi } from "@/lib/api";
import InputText from "@/components/atoms/InputText.vue";

export default Vue.extend({
  components: { InputText },
  props: {
    novelId: String, //小説ID
    items: Array as object, //原稿フォルダ
    manuscriptsCount: Number, //フォルダに含まれる原稿の数
    isInsert: Boolean, //状態管理用。原稿にフォルダを設定する状態かどうかを管理
    selectedManuscript: Object, //フォルダを設定しようとしている原稿
    selectedFolderId: String, //現在表示しているフォルダID
  },
  data() {
    return {
      folders: this.items || [],
      wholeManuscriptCount: null,
      isEditMode: false,
      calling: false,
      pickedDestinationInsertFolder: null,
      toastNoName: null,
      deletedFolderIds: null,
    };
  },
  watch: {
    items() {
      this.folders = this.items;
    },
    manuscriptsCount() {
      this.wholeManuscriptCount = this.manuscriptsCount;
    },
  },
  async created() {
    this.wholeManuscriptCount = this.manuscriptsCount;
  },
  methods: {
    selectFolder(manuscriptFolderId) {
      this.$emit("selectedFolder", manuscriptFolderId);
    },
    async completeSetFolder() {
      const currentManuscriptFolderId = this.selectedFolderId;

      //移動前のフォルダから原稿を抜いて、移動先に原稿を追加する
      this.folders.forEach((el) => {
        if (el.manuscriptFolderId === currentManuscriptFolderId) {
          el.manuscriptKeys.splice(el.manuscriptKeys.indexOf(this.selectedManuscript.key), 1);
        }
        if (el.manuscriptFolderId === this.pickedDestinationInsertFolder) {
          el.manuscriptKeys.push(this.selectedManuscript.key);
        }
      });

      await this.updateManuscriptFolder(this.folders);
      this.$emit("clickCompleteSetFolder");
    },
    clickCancelInsertFolder() {
      this.$emit("clickCancelInsertFolder");
    },
    async createManuscriptFolder() {
      const { novelId } = this;
      const query = `
      mutation CreateManuscriptFolder ($input: CreateManuscriptFolderInput!){
        createManuscriptFolder (input: $input) {
          manuscriptFolderId
          name
        }
      }
      `;
      const { createManuscriptFolder } = await callApi(query, {
        input: {
          novelId,
          name: "新しいフォルダ",
        },
      });
      const folder = {
        manuscriptFolderId: createManuscriptFolder.manuscriptFolderId,
        name: createManuscriptFolder.name,
        manuscriptKeys: [],
      };
      this.folders.push(folder);
    },
    deleteManuscriptFolder(key) {
      if (!this.deletedFolderIds) {
        this.deletedFolderIds = [];
      }
      const result = this.folders.filter((folder) => {
        return folder.manuscriptFolderId !== key;
      });
      this.folders = result;
      this.deletedFolderIds.push(key);
    },
    moveManuscriptFolder(key, direction) {
      let sourceIndex = this.folders.findIndex((folder) => {
        return folder.manuscriptFolderId === key;
      });
      const targetIndex = direction === "up" ? sourceIndex - 1 : sourceIndex + 1;
      if (targetIndex >= 0 || this.folders.length > targetIndex) {
        let temp = this.folders[sourceIndex];
        Vue.set(this.folders, sourceIndex, this.folders[targetIndex]);
        Vue.set(this.folders, targetIndex, temp);
      } else {
      }
    },
    async switchEditMode() {
      //編集終了を押した場合、かつ変更していた場合
      if (this.isEditMode) {
        //フォルダ名が空欄があったら更新しないでエラー出す
        let isExistNoNameFolder = false;
        this.folders.forEach((element) => {
          if (!element.name) {
            isExistNoNameFolder = true;
          }
        });
        if (isExistNoNameFolder) {
          this.toastNoName = true;
          setTimeout(() => (this.toastNoName = null), 2000);
          return;
        }
        await this.updateManuscriptFolder(this.folders);
      }
      this.deletedFolderIds = null;
      this.isEditMode = !this.isEditMode;
    },
    async updateManuscriptFolder(folders) {
      const { novelId } = this;
      const query = `
          mutation UpdateManuscriptFolders ($input: UpdateManuscriptFolderInput!){
            updateManuscriptFolder (input: $input) {
              novelId
              items {
                manuscriptFolderId
                name
                manuscriptKeys
              }
            }
          }
        `;
      //変なデータが有ったらこっそり修正する
      folders.forEach((element) => {
        element.manuscriptKeys = element.manuscriptKeys
          .filter((key) => key != null)
          .filter((el, index, selfArray) => {
            //重複Keyは排除
            return selfArray.indexOf(el) === index;
          });
      });
      const result = await callApi(query, {
        input: {
          novelId,
          items: folders,
        },
      });
      return result;
    },
  },
});
